export default "https://legacy.eskolare-development.com/images/find-institutions.png";